// extracted by mini-css-extract-plugin
export var formContainer = "_fr-0";
export var message = "_fr-1";